import {
  AnalyticsState,
  DailyResults,
  ErrorState,
  TopChannels,
  TopFiles,
  TopUsers,
  UserData,
  UserInfoType,
  UserType,
  GroupType,
  HistoryAudioType,
  HistoryDocumentType,
  PodcastType,
} from '../types/AppTypes';
import {
  FETCHED_DOCUMENTS,
  START_FETCHING_DOCUMENTS,
  FETCHED_DOCUMENT,
  START_FETCHING_DOCUMENT,
  START_PUBLISHING_DOCUMENT,
  PUBLISHED_DOCUMENT,
  START_UPDATING_DOCUMENT,
  UPDATED_DOCUMENT,
  UPDATE_DOCUMENT,
  DELETE_DOCUMENTS,
  SET_USER_DATA,
  SET_START_DATE,
  SET_END_DATE,
  SET_CHANNELS,
  SET_SUBCHANNELS,
  SET_FILTER_CHANNELS,
  SET_FILTER_SUBCHANNELS,
  SET_TOP_FILES,
  SET_TOP_CHANNELS,
  SET_TOP_USERS,
  SET_DAILY_RESULTS,
  SET_ANALYTICS_STATE,
  SET_ERROR,
  SET_TABLE_PAGE_SIZE,
  SET_CURRENT_PAGE,
  START_FETCHING_REPLACEMENTS,
  FETCHED_REPLACEMENTS,
  START_FETCHING_JOBS,
  FETCHED_JOBS,
  START_FETCHING_JOB,
  FETCHED_JOB,
  START_ADDING_JOB,
  ADDED_JOB,
  START_FETCHING_PODCASTS,
  FETCHED_PODCASTS,
  START_ADDING_PODCAST,
  ADDED_PODCAST,
  START_FETCHING_PODCAST,
  FETCHED_PODCAST,
  CLEAR_PODCAST,
  START_UPDATING_PODCAST,
  UPDATED_PODCAST,
  UPDATED_SELECTED_ACRONYMS,
  CHANGE_ACRONYMS_FILTER,
  START_ADDING_URL,
  ADDED_URL,
  CLEAR_URL,
  START_FETCHING_URLS,
  FETCHED_URLS,
  START_FETCHING_USER_INFO,
  FETCHED_USER_INFO,
  START_FETCHING_USERS,
  FETCHED_USERS,
  START_FETCHING_GROUPS,
  FETCHED_GROUPS,
  START_ADDING_GROUP,
  ADDED_GROUP,
  START_UPDATING_GROUP,
  UPDATED_GROUP,
  START_ADDING_USER,
  ADDED_USER,
  START_UPDATING_USER,
  UPDATED_USER,
  START_FETCHING_HISTORY,
  FETCHED_HISTORY,
  SET_FILTERED_DOCUMENTS,
  DELETE_FILTERED_DOCUMENTS,
} from './actionTypes';

import { DocumentType } from '../types/AppTypes';

export const startFetchingDocuments = () => ({
  type: START_FETCHING_DOCUMENTS,
  payload: {},
});

export const fetchedDocuments = (documents: DocumentType | null, message?: string, error?: boolean) => ({
  type: FETCHED_DOCUMENTS,
  payload: {
    documents,
    message,
    error,
  },
});

export const startFetchingDocument = () => ({
  type: START_FETCHING_DOCUMENT,
  payload: {},
});

export const fetchedDocument = (document: DocumentType | null, message?: string, error?: boolean) => ({
  type: FETCHED_DOCUMENT,
  payload: {
    document,
    message,
    error,
  },
});

export const startPublishingDocument = () => ({
  type: START_PUBLISHING_DOCUMENT,
  payload: {},
});

export const startUpdatingDocument = () => ({
  type: START_UPDATING_DOCUMENT,
  payload: {},
});

export const publishedDocument = (id: string) => ({
  type: PUBLISHED_DOCUMENT,
  payload: {
    id,
  },
});

export const updatedDocument = (id: string, message: string, text: string, externalUrl: string, error: boolean) => ({
  type: UPDATED_DOCUMENT,
  payload: {
    id,
    text,
    externalUrl,
    error,
    message,
  },
});

export const updateDocument = (document: DocumentType) => ({
  type: UPDATE_DOCUMENT,
  payload: {
    document,
  },
});

export const deleteDocuments = (documentIds: string[]) => ({
  type: DELETE_DOCUMENTS,
  payload: {
    documentIds,
  },
});

export const setUserData = (payload: UserData) => ({
  type: SET_USER_DATA,
  payload,
});

export const setStartFilterDate = (payload: Date | null) => ({
  type: SET_START_DATE,
  payload: payload?.toString() || '',
});

export const setEndFilterDate = (payload: Date | null) => ({
  type: SET_END_DATE,
  payload: payload?.toString() || '',
});

export const setChannels = (payload: string[]) => ({
  type: SET_CHANNELS,
  payload,
});

export const setSubChannels = (payload: string[]) => ({
  type: SET_SUBCHANNELS,
  payload,
});

export const setFilterChannels = (payload: string[]) => ({
  type: SET_FILTER_CHANNELS,
  payload,
});

export const setFilterSubChannels = (payload: string[]) => ({
  type: SET_FILTER_SUBCHANNELS,
  payload,
});

export const setTopFiles = (payload: TopFiles[]) => ({
  type: SET_TOP_FILES,
  payload,
});

export const setTopChannels = (payload: TopChannels[]) => ({
  type: SET_TOP_CHANNELS,
  payload,
});

export const setTopUsers = (payload: TopUsers[]) => ({
  type: SET_TOP_USERS,
  payload,
});

export const setDailyResults = (payload: DailyResults[]) => ({
  type: SET_DAILY_RESULTS,
  payload,
});

export const setAnalyticsState = (payload: AnalyticsState) => ({
  type: SET_ANALYTICS_STATE,
  payload,
});

export const setError = (payload: ErrorState) => ({
  type: SET_ERROR,
  payload,
});

export const setTablePageSize = (payload: number) => ({
  type: SET_TABLE_PAGE_SIZE,
  payload,
});

export const setCurrentPage = (payload: number) => ({
  type: SET_CURRENT_PAGE,
  payload,
});

export const startFetchingReplacements = () => ({
  type: START_FETCHING_REPLACEMENTS,
  payload: {},
});

export const fetchedReplacements = (replacements: DocumentType[] | null, message?: string, error?: boolean) => ({
  type: FETCHED_REPLACEMENTS,
  payload: {
    replacements,
    message,
    error,
  },
});

export const startFetchingJobs = () => ({
  type: START_FETCHING_JOBS,
  payload: {},
});

export const fetchedJobs = (jobs: DocumentType | null, message?: string, error?: boolean) => ({
  type: FETCHED_JOBS,
  payload: {
    jobs,
    message,
    error,
  },
});

export const startFetchingJob = () => ({
  type: START_FETCHING_JOB,
  payload: {},
});

export const fetchedJob = (job: DocumentType | null, message?: string, error?: boolean) => ({
  type: FETCHED_JOB,
  payload: {
    job,
    message,
    error,
  },
});

export const startAddingJob = () => ({
  type: START_ADDING_JOB,
  payload: {},
});

export const addedJob = (
  name: string,
  rssUrl: string,
  customerId: string,
  schedule: string,
  message: string,
  error: boolean,
) => ({
  type: ADDED_JOB,
  payload: {
    name,
    rssUrl,
    customerId,
    schedule,
    message,
    error,
  },
});

export const startFetchingPodcasts = () => ({
  type: START_FETCHING_PODCASTS,
  payload: {},
});

export const fetchedPodcasts = (podcasts: PodcastType[] | null, message?: string, error?: boolean) => ({
  type: FETCHED_PODCASTS,
  payload: {
    podcasts,
    message,
    error,
  },
});

export const startAddingPodcast = () => ({
  type: START_ADDING_PODCAST,
  payload: {},
});

export const addedPodcast = (
  id: string,
  author: string,
  title: string,
  category: string,
  language: string,
  publisher: string,
  publicationLocation: string | undefined,
  publicationYear: string | undefined,
  description: string,
  type: string,
  parser: string,
  contentType: number,
  pollyLanguages: string,
  image: File,
  groups: string,
  retrieval: boolean,
  message: string,
  error: boolean,
) => ({
  type: ADDED_PODCAST,
  payload: {
    id,
    author,
    title,
    category,
    language,
    publisher,
    publicationLocation,
    publicationYear,
    description,
    type,
    parser,
    contentType,
    pollyLanguages,
    image,
    groups,
    retrieval,
    message,
    error,
  },
});

export const startUpdatingPodcast = () => ({
  type: START_UPDATING_PODCAST,
  payload: {},
});

export const updatedPodcast = (
  id: string,
  author: string,
  title: string,
  category: string,
  language: string,
  publisher: string,
  publicationLocation: string | undefined,
  publicationYear: string | undefined,
  description: string,
  type: string,
  parser: string,
  contentType: number,
  pollyLanguages: string,
  image: File | null,
  groups: string,
  retrieval: boolean,
  message: string,
  error: boolean,
  episodesOrderList?: string[],
) => ({
  type: UPDATED_PODCAST,
  payload: {
    id,
    author,
    title,
    category,
    language,
    publisher,
    publicationLocation,
    publicationYear,
    description,
    type,
    parser,
    contentType,
    pollyLanguages,
    image,
    groups,
    retrieval,
    message,
    error,
    episodesOrderList,
  },
});

export const startFetchingPodcast = () => ({
  type: START_FETCHING_PODCAST,
  payload: {},
});

export const fetchedPodcast = (podcast: DocumentType | null, message?: string, error?: boolean) => ({
  type: FETCHED_PODCAST,
  payload: {
    podcast,
    message,
    error,
  },
});

export const clearPodcast = () => ({
  type: CLEAR_PODCAST,
  payload: {},
});

export const setFilteredAcronyms = (acronyms: any[]) => ({
  type: UPDATED_SELECTED_ACRONYMS,
  payload: acronyms,
});

export const setAcronymsFilter = (filter: string | null) => ({
  type: CHANGE_ACRONYMS_FILTER,
  payload: filter,
});

export const startAddingUrl = () => ({
  type: START_ADDING_URL,
  payload: {},
});

export const addedUrl = (
  documentId: string,
  customerId: string,
  description: string,
  mp3url: string,
  message: string,
  error: boolean,
) => ({
  type: ADDED_URL,
  payload: {
    documentId,
    customerId,
    description,
    mp3url,
    message,
    error,
  },
});

export const startFetchingUrls = () => ({
  type: START_FETCHING_URLS,
  payload: {},
});

export const fetchedUrls = (urls: DocumentType | null, message?: string, error?: boolean) => ({
  type: FETCHED_URLS,
  payload: {
    urls,
    message,
    error,
  },
});

export const clearUrl = () => ({
  type: CLEAR_URL,
  payload: {},
});

export const startFetchingUserInfo = () => ({
  type: START_FETCHING_USER_INFO,
  payload: {},
});

export const fetchedUserInfo = (userInfo: UserInfoType | null, message?: string, error?: boolean) => ({
  type: FETCHED_USER_INFO,
  payload: {
    userInfo,
    message,
    error,
  },
});

export const startFetchingUsers = () => ({
  type: START_FETCHING_USERS,
  payload: {},
});

export const fetchedUsers = (users: UserType | null, message?: string, error?: boolean) => ({
  type: FETCHED_USERS,
  payload: {
    users,
    message,
    error,
  },
});

export const startFetchingGroups = () => ({
  type: START_FETCHING_GROUPS,
  payload: {},
});

export const fetchedGroups = (groups: GroupType | null, message?: string, error?: boolean) => ({
  type: FETCHED_GROUPS,
  payload: {
    groups,
    message,
    error,
  },
});

export const startAddingGroup = () => ({
  type: START_ADDING_GROUP,
  payload: {},
});

export const addedGroup = (groupId: string, actions: string[], message: string, error: boolean) => ({
  type: ADDED_GROUP,
  payload: {
    groupId,
    actions,
    message,
    error,
  },
});

export const startUpdatingGroup = () => ({
  type: START_UPDATING_GROUP,
  payload: {},
});

export const updatedGroup = (groupId: string, actions: string[], message: string, error: boolean) => ({
  type: UPDATED_GROUP,
  payload: {
    groupId,
    actions,
    message,
    error,
  },
});

export const startAddingUser = () => ({
  type: START_ADDING_USER,
  payload: {},
});

export const addedUser = (username: string, groups: string[], message: string, error: boolean) => ({
  type: ADDED_USER,
  payload: {
    username,
    groups,
    message,
    error,
  },
});

export const startUpdatingUser = () => ({
  type: START_UPDATING_USER,
  payload: {},
});

export const updatedUser = (username: string, groups: string[], message: string, error: boolean) => ({
  type: UPDATED_USER,
  payload: {
    username,
    groups,
    message,
    error,
  },
});

export const startFetchingHistory = () => ({
  type: START_FETCHING_HISTORY,
  payload: {},
});

export const fetchedHistory = (
  historyAudio: HistoryAudioType | null,
  historyDocument: HistoryDocumentType | null,
  message?: string,
  error?: boolean,
) => ({
  type: FETCHED_HISTORY,
  payload: {
    historyAudio,
    historyDocument,
    message,
    error,
  },
});

export const setFilteredDocuments = (payload: DocumentType[]) => ({
  type: SET_FILTERED_DOCUMENTS,
  payload: payload,
});

export const deleteFilteredDocuments = (documentIds: string[]) => ({
  type: DELETE_FILTERED_DOCUMENTS,
  payload: { documentIds },
});
